import { hydrate } from "svelte";
import { type SSRData } from "@kestrel/client";
import Root from "./root.svelte";
import { getComponent } from "./component";

/**
 *
 *
 *
 *
 */
export async function start(current: HTMLScriptElement, { id }: { id: string }): Promise<void> {
  const container = current.parentElement;
  if (!container && import.meta.env.DEV) {
    throw new Error("current script element is not attached to a parent");
  }

  const dataElement = container!.querySelector<HTMLScriptElement>(
    `script[type='application/json'][data-kestrel-id='${id}']`,
  );

  if (!dataElement && import.meta.env.DEV) {
    throw new Error("No data element found in container");
  }

  const { textContent } = dataElement!;
  if (!textContent && import.meta.env.DEV) {
    throw new Error("Data element does not contains ssr state");
  }

  const ssrState = JSON.parse(textContent!) as SSRData;
  if (!ssrState.routeId && !ssrState.error && import.meta.env.DEV) {
    throw new Error("Invalid ssr state, missing routeId");
  }

  const component = await getComponent(ssrState.routeId, ssrState.error);
  hydrate(Root, { target: container!, props: { ...ssrState, component } });
}
